export default __webpack_public_path__ + "i18n/translations/translation-ml.478a67cd.json";